import { Component, OnInit, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IAction, IActionSubtype } from '../../../model/action.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Observable, Subject, tap } from 'rxjs';
import { ProductsService } from 'src/app/services/products.service';

@UntilDestroy()
@Component({
    selector: 'app-order-query-action-form',
    templateUrl: './order-query-action-form.component.html',
    styleUrls: ['./order-query-action-form.component.scss'],
})
export class OrderQueryActionFormComponent implements OnInit {
    @Input() subFormIsLoading$: Subject<boolean>;
    @Input() form: FormGroup;
    @Input() action: IAction;

    allProducts: any[];
    selectedProducts = [];

    constructor(private productsService: ProductsService) {}

    ngOnInit(): void {
        this.loadFormData().subscribe(() => {
            this.extendFormControls();
            this.selectedProducts = this.allProducts.filter((p) => this.action.products.includes(p.id));
            this.subFormIsLoading$.next(false);
        });
    }

    removeProduct(product) {
        this.selectedProducts = this.selectedProducts.filter((p) => p.id !== product.id);
        this.form.get('products').setValue(this.selectedProducts.map((p) => p.id));
    }

    private loadFormData(): Observable<any> {
        return this.productsService
            .findAll()
            .pipe(untilDestroyed(this))
            .pipe(
                tap((res: any) => {
                    this.allProducts = res.data;
                })
            );
    }

    private extendFormControls() {
        this.form.addControl('query', new FormControl(this.action.query, [Validators.required]));
        this.form.addControl('subject', new FormControl(this.action.subject, [Validators.required]));
        this.form.addControl('customerId', new FormControl(this.action.customer?.id));
        this.form.addControl('sendNotificationToCustomer', new FormControl(false));
        this.form.addControl('products', new FormControl(this.action.products));
        this.form.get('products').valueChanges.subscribe((productIds) => {
            this.selectedProducts = this.allProducts.filter((p) => productIds.includes(p.id));
        });
    }
}
